import dynamic from 'next/dynamic';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//hooks
import useToggle from '@/utils/hooks/utils/useToggle';

//components
import Button from '@/components/base/Button';
const ModalNetworkSuggestion = dynamic(() =>
    import(
        '@/components/composite/Button/ButtonsInsight/ButtonNetworkSuggestion/ModalNetworkSuggestion'
    ).then((mod) => mod.ModalNetworkSuggestion)
);

export function ButtonNetworkSuggestion({
    variant = 'white',
    size = 'md',
    disabled,
    className,
    children
}: React.ComponentProps<typeof Button>) {
    const { t } = useTranslation('future_integration');
    const { isOpen, toggle } = useToggle();

    return (
        <>
            <Button
                variant={variant}
                size={size}
                disabled={disabled}
                onClick={toggle}
                className={className}
                data-testid="suggest-network-button">
                {children}
                <span>{t('looking_for_other_platform')}</span>
            </Button>
            <ModalNetworkSuggestion isOpen={isOpen} closeModal={toggle} />
        </>
    );
}
